import { isPlatform } from '@ionic/react';

const NumToShortMonthMap = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec'
};
const NumToFullMonthMap = {
    '01': 'January',
    '02': 'February',
    '03': 'March',
    '04': 'April',
    '05': 'May',
    '06': 'June',
    '07': 'July',
    '08': 'August',
    '09': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December'
};
const Hour24To12Map = {
    '00': '00',
    '01': '01',
    '02': '02',
    '03': '03',
    '04': '04',
    '05': '05',
    '06': '06',
    '07': '07',
    '08': '08',
    '09': '09',
    '10': '10',
    '11': '11',
    '12': '12',
    '13': '01',
    '14': '02',
    '15': '03',
    '16': '04',
    '17': '05',
    '18': '06',
    '19': '07',
    '20': '08',
    '21': '09',
    '22': '10',
    '23': '11'
};

const GetDayOfWeek = (date: Date) => {
    const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    return daysOfWeek[date.getDay()];
}

//EXPORTS
export const IonDate = (date: string) => {
    let res: Date;
    if (isPlatform('ios')) {

        let t: string[] = [];
        date.includes(',') ?
            t = (date.replace(',', '')).split(/[- :]/)
            :
            t = date.split(/[- :]/);

        // Apply each element to the Date function
        res = new Date(parseInt(t[0]), parseInt(t[1]) - 1, parseInt(t[2]), parseInt(t[3]), parseInt(t[4]), parseInt(t[5]));
    } else {
        res = new Date(date);
    }

    if(!(res instanceof Date) || isNaN(res.getTime())) {
        // console.log('IonDateErr: InvalidDateErr: ' + date);
        res = new Date();
    }

    return res;
};

export const IonDateFormat = {
    'MYSQL_STANDARD': 0, //YYYY-mm-dd HH:ii:ss      2024-11-18 06:21:00
    'LONG_DATE': 1, //MONTH dd, YYYY        November 18, 2024
    'LONG_DATE_TIME': 2, //DAY, MONTH dd, YEAR, hh:ii am/pm      Mon, Nov 18, 2024, 06:25 am 
    'MALAYSIA_STANDARD': 3, //dd/mm/yyyy HH:ii am/pm
    'MALAYSIA_STANDARD_DATE': 4, //dd/mm/yyyy
    'TIME_12': 5,
    'TIME_24': 6,
    'YEAR_ONLY': 7
}
export const IonDateString = (date: Date | null, format: number = 0): string => {
    if (date != null) {
        const dateTimeStringArr = date.toLocaleString('en-US', { hour12: false }).split(', ');
        const dateStringArr = dateTimeStringArr[0].split('/');
        const timeString = dateTimeStringArr[1];
        const timeStringArr = timeString.split(':');

        switch (format) {
            default:
            case IonDateFormat.MYSQL_STANDARD:
                return dateStringArr[2] + '-' + dateStringArr[0].padStart(2, '0') + '-' + dateStringArr[1].padStart(2, '0') + ' ' + timeString;
            case IonDateFormat.LONG_DATE:
                return NumToFullMonthMap[dateStringArr[0].padStart(2, '0') as keyof typeof NumToFullMonthMap] + ' ' + dateStringArr[1].padStart(2, '0') + ', ' + dateStringArr[2];
            case IonDateFormat.LONG_DATE_TIME:
                return GetDayOfWeek(date) + ', ' + NumToFullMonthMap[dateStringArr[0].padStart(2, '0') as keyof typeof NumToFullMonthMap] + ' ' + dateStringArr[1].padStart(2, '0') + ', ' + dateStringArr[2] + ' '
                    + Hour24To12Map[timeStringArr[0].padStart(2, '0') as keyof typeof Hour24To12Map] + ':' + timeStringArr[1] + ' ' + (parseInt(timeStringArr[0]) >= 12 ? 'PM' : 'AM');
            case IonDateFormat.MALAYSIA_STANDARD:
                return dateStringArr[1].padStart(2, '0') + '/' + dateStringArr[0].padStart(2, '0') + '/' + dateStringArr[2] + ' ' +
                        Hour24To12Map[timeStringArr[0].padStart(2, '0') as keyof typeof Hour24To12Map] + ':' + timeStringArr[1] + ' ' + (parseInt(timeStringArr[0]) >= 12 ? 'PM' : 'AM');
            case IonDateFormat.MALAYSIA_STANDARD_DATE:
                return dateStringArr[1].padStart(2, '0') + '/' + dateStringArr[0].padStart(2, '0') + '/' + dateStringArr[2];
            case IonDateFormat.TIME_12:
                return Hour24To12Map[timeStringArr[0].padStart(2, '0') as keyof typeof Hour24To12Map] + ':' + timeStringArr[1] + ' ' + (parseInt(timeStringArr[0]) >= 12 ? 'PM' : 'AM');
            case IonDateFormat.TIME_24:
                return timeStringArr[0].padStart(2, '0') + ':' + timeStringArr[1];
            case IonDateFormat.YEAR_ONLY:
                return dateStringArr[2];
        }
    }
    else {
        // console.log('IonDateStringErr: DateNullErr: ' + JSON.stringify(date));
        return 'NA';
    }
}
export const IsIonDateFormat = (subjectVal: number) => {
    let res = false;
    Object.keys(IonDateFormat).map((key: string) => {
        if(IonDateFormat[key as keyof typeof IonDateFormat] == subjectVal)
            res = true;
    });
    if(!res)
        console.log('IsIonDateFormatErr: ' + subjectVal + ' is not found in IonDateFormat.');
    return res;
}